module.exports = __webpack_public_path__ + "img/icon_next.eff9d3a7.svg";